import React, {useMemo} from "react";
import {Container} from "react-bootstrap";
import NutzungLayout from "../../Components/Nutzung/NutzungLayout.jsx";
import useNutzungFilter from "../../Components/Nutzung/useNutzungFilter.js";
import useStatisticsData from "../../Components/Statistics/useStatisticsData.js";
import NutzungMitarbeiterTabelle from "../../Components/Nutzung/NutzungMitarbeiterTabelle.jsx";

/**
 * Vollständige, sortierbare Mitarbeitertabelle - jetzt im gemeinsamen
 * Rahmen (NutzungLayout) und mit Bereichsspalte. Die Bereichsverteilung
 * kommt für ALLE Mitarbeiter in einem einzigen Aufruf
 * (/nutzung/daten/mitarbeiter-bereiche, Spezifikation Abschnitt 3) - derselbe
 * Matrix-Endpunkt, auf den NutzungMitarbeiterBereiche.jsx (zuständig für den
 * Überblick) beim Abgleich der Nutzungsauswertung ebenfalls umgestellt wurde.
 */
export default function NutzungMitarbeiter() {
    const nutzungFilters = useNutzungFilter();
    const {filters} = nutzungFilters;

    const bereicheAntwort = useStatisticsData("/nutzung/daten/mitarbeiter-bereiche", filters);
    const bereicheProps = useMemo(() => {
        const rows = Array.isArray(bereicheAntwort.data) ? bereicheAntwort.data : [];
        return Object.fromEntries(rows.map((eintrag) => [String(eintrag.user_id), eintrag.bereiche || []]));
    }, [bereicheAntwort.data]);

    return (
        <Container fluid className="pt-2 pb-4">
            <NutzungLayout gruppe="Mitarbeiter" titel="Alle Mitarbeiter" nutzungFilters={nutzungFilters}>
                <NutzungMitarbeiterTabelle filters={filters} bereicheProps={bereicheProps} bereicheLoading={bereicheAntwort.loading} />
            </NutzungLayout>
        </Container>
    );
}
